/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var UIUtil = require('psa-core/util/ui');

var SideNavSectionView = require('common/views/SideNavSectionView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var DropdownView = require('common/views/DropdownView');
var ConfirmationModalView = require('common/views/ConfirmationModalView');

var SubmitLocation = require('../services/SubmitLocation');

var DepLocationDetailsSectionView = require('./DepLocationDetailsSectionView');

var tmplDepLocationDashboardView = require('../templates/DepLocationDashboardView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepLocationDashboardView,

  className: 'dep-location-dashboard-view container-fluid',

  ui: {
    locationWrapper: '.location-wrapper',
    breadcrumb: '.breadcrumb-container',
    csLinkContainer: '.cs-link-container',
    entityActionDropDown: '.dropdown-container'
  },

  regions: {
    locationWrapper: '@ui.locationWrapper',
    breadcrumb: '@ui.breadcrumb',
    csLinkContainer: '@ui.csLinkContainer',
    entityActionDropDown: '@ui.entityActionDropDown'
  },

  onBeforeShow: function() {
    var location = this.model.get('location') || {};
    var entityIdentifiers = this.model.get('entityIdentifiers') || {};

    var locationId = this.model.get('locationId');
    var entityName = entityIdentifiers.entityName;
    var entityId = this.model.get('entityId');

    var dropDownOptions = [
      {
        text: 'Edit Location',
        link: '#dep/entity/' + entityId + '/location/' + locationId + '/edit'
      },
      {
        text: 'Delete Location',
        onClick: this.onClickDelete.bind(this)
      }
    ];

    this.showChildView(
      'entityActionDropDown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Location Actions',
          options: dropDownOptions
        })
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            text: 'Opened on ' + location.openedDate + ' - ' + location.status
          }
        ]
      })
    );

    this.location = new SideNavSectionView({
      useNavigationButtons: false,
      collection: new Backbone.Collection([
        {
          id: 'locationDetails',
          title: 'Location Details',
          view: new DepLocationDetailsSectionView({
            model: new Backbone.Model(_.extend(location, { entityIdentifiers: entityIdentifiers })),
            locationType: this.options.locationType
          })
        },
        {
          id: 'notes',
          title: 'Notes',
          view: Radio.channel('dp').request('build:notes-view', {
            objectId: locationId,
            objectTypeId: 'LOCATION'
          })
        },
        {
          id: 'auditLog',
          title: 'Audit Log',
          view: Radio.channel('dp').request('build:audit-log-view', {
            objectId: locationId,
            objectTypeId: 'LOCATION'
          })
        }
      ])
    });
    this.showChildView('locationWrapper', this.location);
  },

  onClickDelete: function() {
    var self = this;
    var message = 'Are you sure you want to delete this location?';
    UIUtil.showModal({
      title: 'Confirm Deleting Location',
      view: new ConfirmationModalView({
        confirmText: 'Delete Location',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var locationId = self.model.get('locationId');
            return SubmitLocation({ locationId: locationId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            var entityId = self.model.get('entityId');
            Radio.channel('navigate').trigger('show:int:dp:entity', entityId);
          }
        })
      })
    });
  }
});
